import { AnyAction } from "redux";
import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../get-action-types";

function getErrorReducer<T extends string>(types: T[]) {
  if (types.length === 1) {
    let type = types[0]; //we don't have types, we got only one action type
    return function errorReducer(state = {}, action: AnyAction) {
      switch (action.type) {
        case getRequestActionType(type):
        case getSuccessActionType(type):
          return {};
        case getFailureActionType(type):
          return action.payload;
        default:
          return state;
      }
    };
  } else {
    let requestActions = types.map((type) => getRequestActionType(type));
    let successActions = types.map((type) => getSuccessActionType(type));
    let failureActions = types.map((type) => getFailureActionType(type));
    return function errorReducer(state = {}, action: AnyAction) {
      if (requestActions.includes(action.type) || successActions.includes(action.type)) {
        return {};
      } else if (failureActions.includes(action.type)) {
        return action.payload;
      } else {
        return state;
      }
    };
  }
}

export default getErrorReducer;
